module.exports = __webpack_public_path__ + "static/Elements_43-930775147b1b32a337ba97e906a12a93.jpg";